var React = require('react');

function Phone24px (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Mijn telefoonnummer: 06-58910956"),React.createElement("desc",{"key":1},"Een icoon dat werkt als link naar mijn telefoonnummer"),React.createElement("path",{"d":"M0 0h24v24H0V0z","fill":"none","key":2}),React.createElement("path",{"d":"M19.23 15.26l-2.54-.29c-.61-.07-1.21.14-1.64.57l-1.84 1.84c-2.83-1.44-5.15-3.75-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52c-.12-1.01-.97-1.77-1.99-1.77H5.03c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98z","key":3})]);
}

Phone24px.defaultProps = {"height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Phone24px;

Phone24px.default = Phone24px;
